function addVariantSelectors() {
  document.querySelectorAll("a.addsingleproduct:not([data-variants-loaded])").forEach(function (btn) {

    btn.setAttribute("data-variants-loaded", "true");

    var productUrl = btn.getAttribute("data-url");
    var variantCount = parseInt(btn.getAttribute("data-variant_count"));

    if (variantCount <= 1) return;

    fetch(productUrl + ".js")
      .then(function (res) { return res.json(); })
      .then(function (product) {

        var select = document.createElement("select");
        select.className = "swl-variant-select";
        select.style.cssText = "";

        product.variants.forEach(function (variant) {
          var option = document.createElement("option");
          option.value = variant.id;
          option.textContent = variant.title;
          if (!variant.available) {
            option.textContent = variant.title;
            option.disabled = true;
          }
          select.appendChild(option);
        });

        select.addEventListener("change", function () {
          btn.setAttribute("data-variantid", this.value);
        });

var savedVariantId = btn.getAttribute("data-variantid");
var savedVariant = product.variants.find(function (v) { return v.id == savedVariantId; });

if (savedVariant && savedVariant.available) {
  select.value = savedVariantId;
} else {
  var firstAvailable = product.variants.find(function (v) { return v.available; });
  if (firstAvailable) {
    select.value = firstAvailable.id;
    btn.setAttribute("data-variantid", firstAvailable.id);
  }
}

        btn.parentNode.insertBefore(select, btn);
      });
  });
}

if (window.location.pathname.includes("/a/wishlist")) {
  var observer = new MutationObserver(function () {
    addVariantSelectors();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Kør også ved load i tilfælde af at knapperne allerede er der
  document.addEventListener("DOMContentLoaded", addVariantSelectors);
}
function fixDoubleCurrency() {
  document.querySelectorAll("span.price").forEach(function (el) {
    // Fjern alt der ikke er tal, komma, punktum eller store bogstaver til sidst
    el.textContent = el.textContent.replace(/^[^0-9]+/, "").trim();
  });
}
if (window.location.pathname.includes("/a/wishlist")) {
  document.addEventListener("DOMContentLoaded", fixDoubleCurrency);
  setTimeout(fixDoubleCurrency, 1500);
}